(function (Drupal, $) {

  'use strict';

  Drupal.behaviors.dataTag = {
    attach: function (context, settings) {
      $(document).on('init breakpoint', '.slick-slider', function () {
        $('[data-tag]').filter(function () {
          const slickItemParent = $(this).closest('.slick-slide');
          return slickItemParent.length > 0 && !slickItemParent.hasClass('slick-cloned');
        });

        const allClonedItems = $('.slick-slide.slick-cloned');

        allClonedItems.each(function () {
          const dataTag = $(this).find('[data-tag]');
          if (dataTag.length > 0) {
            const classes = dataTag.attr('class');
            
            dataTag.replaceWith(`<span class="${classes}">${dataTag.text()}</span>`);
          }
        });
      });
    }
  }
})(Drupal, jQuery);
